import React from "react";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";

const VendorMachineCard = ({ machine, type, handleSelectImage }) => {
  console.log("machine", machine);
  return type == "Printing" ? (
    <div
      key={machine._id}
      className="rounded-xl border border-[#D4D8E1] bg-white overflow-hidden"
    >
      <div className="p-6">
        {/* Title */}
        <div className="flex items-start justify-between mb-5">
          <h3 className="text-[18px] font-semibold text-[#1F2937]">
            {machine?.machinePrintingType || "-"}
          </h3>

          <span className="text-lg text-[#4B5563]">
            <PrintOutlinedIcon />
          </span>
        </div>

        {/* Image */}
        {machine?.PrintingMachineImage ? (
          <img
            src={machine.PrintingMachineImage}
            alt={machine?.machinePrintingType}
            className="h-[120px] w-full rounded-md object-cover cursor-pointer"
            onClick={() => handleSelectImage(machine.PrintingMachineImage)}
          />
        ) : (
          <div className="flex h-[120px] w-full items-center justify-center rounded-md border border-dashed border-slate-300 bg-slate-50 text-sm font-medium text-slate-400">
            No Image Available
          </div>
        )}

        {/* Details */}
        <div className="mt-6 space-y-3">
          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Printing Type</span>
            <span className="font-medium">
              {machine?.machinePrintingSubType || "-"}
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Brand</span>
            <span className="font-medium">{machine?.machineBrand || "-"}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Max Print Size</span>
            <span className="font-medium">
              {machine?.maxPrintSize || "-"} ft
            </span>
          </div>

          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Age</span>
            <span className="font-medium">
              {machine?.ageOfMachine || "-"} Years
            </span>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div
      key={machine.category}
      className="rounded-xl border border-[#D4D8E1] bg-white overflow-hidden"
    >
      <div className="p-6">
        {/* Title */}
        <div className="flex items-start justify-between mb-5">
          <h3 className="text-[18px] font-semibold text-[#1F2937]">
            {machine?.category}
          </h3>

          <span className="text-lg text-[#4B5563]">
            <PrecisionManufacturingOutlinedIcon />
          </span>
        </div>

        {/* Image */}
        {machine?.fabricationMachineImage ? (
          <img
            src={machine.fabricationMachineImage}
            alt={machine?.category}
            className="h-[120px] w-full rounded-md object-cover cursor-pointer"
            onClick={() => handleSelectImage(machine.fabricationMachineImage)}
          />
        ) : (
          <div className="flex h-[120px] w-full items-center justify-center rounded-md border border-dashed border-slate-300 bg-slate-50 text-sm font-medium text-slate-400">
            No Image Available
          </div>
        )}

        {/* Specs */}
        <div className="mt-6 space-y-3">
          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Sub Category</span>
            <span className="font-medium">{machine?.subCategory || "-"}</span>
          </div>

          <div className="flex justify-between">
            <span className="text-sm text-slate-500">Age</span>
            <span className="font-medium">
              {machine?.ageOfMachine || "-"} Years
            </span>
          </div>

          {machine?.wattage && (
            <div className="flex justify-between">
              <span className="text-sm text-slate-500">Wattage</span>
              <span className="font-medium">{machine.wattage}</span>
            </div>
          )}

          {machine?.ampereOfMachine && (
            <div className="flex justify-between">
              <span className="text-sm text-slate-500">Ampere</span>
              <span className="font-medium">{machine.ampereOfMachine}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorMachineCard;
